// Module
var code = "<div class=pull-right><div ng-transclude></div></div>";
// Exports
module.exports = code;